export const CID_PREFIX = 'cid:';
export const ORIGINAL_SRC_ATTRIBUTE = 'originalsrc';
